import { render, staticRenderFns } from "./SupervisorGroupMaintain.vue?vue&type=template&id=0445198a&scoped=true"
import script from "./SupervisorGroupMaintain.vue?vue&type=script&lang=js"
export * from "./SupervisorGroupMaintain.vue?vue&type=script&lang=js"
import style0 from "./SupervisorGroupMaintain.vue?vue&type=style&index=0&id=0445198a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0445198a",
  null
  
)

export default component.exports